import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { clone, isEmpty, isNil } from "ramda";

import palette from "../../../config/colorPalette";
import { Box, Button, Checkbox, FormControlLabel, MenuItem, TextField } from "@mui/material";
import { handleInterMeasurementTime, offsetPolygonPerSegment, updateData } from "./utils/utils";

import { ErrorText } from "./styled";
import LoadingButton from "@mui/lab/LoadingButton";
import { getAssetsDataAction } from "../../redux/assetsSlice";
import { getConfigDataAction } from "../../redux/configSlice";

import ChannelInfo from "./components/channelinfo";
import MeasurementInfo from "./components/measurementInfo";
import { getPointsByAssets } from "../../api";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { pingIpAddress } from "../../api";
import { toast } from "react-toastify";

const Configuration = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const assets = useSelector((state) => state.assetsData);
  const currentConfig = useSelector((state) => state.configData);
  const currentUser = useSelector((state) => state.userData.data);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [selectedEquipmentID, setSelectedEquipmentID] = useState(null);
  const [assetSensors, setAssetSensors] = useState(null);
  const [channelsSensorsIDs, setchannelSensorsIDs] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [dataReloadTime, setDataReloadTime] = useState(0);
  const [alertTimeRange, setAlertTimeRange] = useState(0);
  const [measuresAlerts, setMeasuresAlerts] = useState([]);
  const [tuples, setTuples] = useState([]);
  const [tuplesActive, setTuplesActive] = useState([]);
  const [thresholdsRanges, setThresholdsRanges] = useState([]);
  const [equipments, setEquipments] = useState([]);

  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPing, setLoadingPing] = useState(false);
  const disabled = useMemo(() => !isEmpty(errors) || loading, [errors, loading]);
  const disabledPing = useMemo(
    () => (!isEmpty(errors) && !isNil(errors[selectedEquipmentID + "_IP"])) || loadingPing,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [errors, loadingPing],
  );
  const equipmentTypes = useSelector((state) => state.equipmentTypeData.data);
  const [objectMeasures, setObjectMeasures] = useState(null);
  const [currentEquipmentType, setCurrentEquipmentType] = useState(null);

  const [measureToggle, setMeasureToggle] = useState([]);
  const [channelToggle, setChannelToggle] = useState([]);
  const [zoneToggle, setZoneToggle] = useState([]);

  const [asignedChannelNames, setAsignedChannelNames] = useState();
  const [asignedChannelLength, setAsignedChannelLength] = useState();
  const [asignedChannelSpatialResolution, setAsignedChannelSpatialResolution] = useState();
  const [asignedChannelSamplingInterval, setAsignedChannelSamplingInterval] = useState();
  const [asignedChannelMeasurementTime, setAsignedChannelMeasurementTime] = useState();
  const [asignedChannelAcquisition, setAsignedChannelAcquisition] = useState();
  const [asignedChannelGaugelength, setAsignedChannelGaugelength] = useState();
  const [asignedChannelsStates, setAsignedChannelsStates] = useState();
  const [asignedChannelsInfo, setAsignedChannelsInfo] = useState();
  const [realState, setRealState] = useState(true);
  const [channelDataToggle, setChannelDataToggle] = useState();
  const [asignedChannelSubstructures, setAsignedChannelSubstructures] = useState();
  const [asignedChannelSubstructuresToggle, setAsignedChannelSubstructuresToggle] = useState();
  const [equipmentInterMeasurement, setEquipmentInterMeasurement] = useState();
  const [points, setPoints] = useState();

  //const roleInAssetDemarcation = currentUser.assetsConfigurations[demarcation].assets[selectedAsset.name];
  useEffect(() => {
    if (!isNil(equipmentTypes)) {
      const newData = equipmentTypes.map((item) => {
        const measures = [];
        const computing = [];
        item.pMeasureNames.forEach((measure, index) => {
          if (item.pMeasureComputed[index] === 0) {
            measures.push(measure);
          } else {
            computing.push(measure);
          }
        });

        const newEntry = { name: item.name, measures: measures };
        if (computing.length > 0) {
          newEntry.computing = computing;
        }
        return newEntry;
      });
      setObjectMeasures(newData);
    }
  }, [equipmentTypes]);
  async function getPoints(name) {
    const pointsRequest = await getPointsByAssets(name);
    setPoints({ asset: name, points: pointsRequest.data.data });
  }

  useMemo(() => {
    if (!isNil(assets.data) && !isEmpty(assets.data) && !isNil(currentConfig.data)) {
      const AssetConfigHasData = !isNil(currentUser.assetsConfigurations) && !isEmpty(currentUser.assetsConfigurations);
      if (!AssetConfigHasData) {
        setSelectedAsset(assets.data[0]);
        setAlertTimeRange(assets.data[0].alertTimeRange / 60);
        setEquipments(assets.data[0].equipments ?? []);
        setSelectedEquipment(assets.data[0].equipments[0]);
        setSelectedEquipmentID(assets.data[0].equipments[0].equipmentID);
        setDataReloadTime(currentConfig.data.loadTime);
        const assetSensIDs = [];
        for (let index = 0; index < assets.data[0].sensors.length; index++) {
          assetSensIDs.push(assets.data[0].sensors[index].sensor_ID);
        }
        setAssetSensors(assetSensIDs);
        if (isNil(selectedAsset)) {
          getPoints(assets.data[0].name);
        }
      } else {
        for (let assetIndex = 0; assetIndex < assets.data.length; assetIndex++) {
          const demarcation = assets.data[assetIndex].demarcation;
          if (
            !isNil(currentUser.assetsConfigurations[demarcation]) &&
            currentUser.assetsConfigurations[demarcation].role !== "viewer" &&
            currentUser.assetsConfigurations[demarcation].assets[assets.data[assetIndex].name] !== "viewer"
          ) {
            setSelectedAsset(assets.data[assetIndex]);
            setAlertTimeRange(assets.data[assetIndex].alertTimeRange / 60);
            setEquipments(assets.data[assetIndex].equipments ?? []);
            setSelectedEquipment(assets.data[assetIndex].equipments[0]);
            setSelectedEquipmentID(assets.data[assetIndex].equipments[0].equipmentID);
            setDataReloadTime(currentConfig.data.loadTime);
            const assetSensIDs = [];
            for (let index = 0; index < assets.data[assetIndex].sensors.length; index++) {
              assetSensIDs.push(assets.data[assetIndex].sensors[index].sensor_ID);
            }
            setAssetSensors(assetSensIDs);
            if (isNil(selectedAsset)) {
              getPoints(assets.data[assetIndex].name);
            }

            break;
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assets, currentConfig]);

  useEffect(() => {
    if (!isNil(selectedEquipment) && !isNil(objectMeasures) && realState) {
      setTuples(selectedEquipment.pThresholds);
      setTuplesActive(selectedEquipment.pThresholdsActive);
      setMeasuresAlerts(selectedEquipment.pMeasureAlerts);
      setThresholdsRanges(selectedEquipment.pThresholdsRanges);
      setAsignedChannelNames(selectedEquipment.channelsNames);
      setAsignedChannelLength(selectedEquipment.channelsLength);
      setAsignedChannelSpatialResolution(selectedEquipment.channelsSpatialResolution);
      setAsignedChannelSamplingInterval(selectedEquipment.channelsSamplingInterval);
      setAsignedChannelMeasurementTime(selectedEquipment.channelsMeasurementTime);
      setAsignedChannelAcquisition(selectedEquipment.channelsAcquisitionFrequency);
      setAsignedChannelGaugelength(selectedEquipment.channelsGaugeLength);
      setAsignedChannelsStates(selectedEquipment.channelsStates);
      setAsignedChannelsInfo(selectedEquipment.channelsInfo);
      setchannelSensorsIDs(selectedEquipment.channelsSensorsIDs);
      setAsignedChannelSubstructures(selectedEquipment.channelsSubStructures);
      const subToggle = [];
      for (let indexChannel = 0; indexChannel < selectedEquipment.channelsSubStructures.length; indexChannel++) {
        subToggle.push([]);
        for (let indexSub = 0; indexSub < selectedEquipment.channelsSubStructures.length; indexSub++) {
          subToggle[indexChannel].push(false);
        }
      }
      setAsignedChannelSubstructuresToggle(subToggle);

      const newErrors = {};
      const suma = !isNil(selectedEquipment.channelsMeasurementTime)
        ? selectedEquipment.channelsMeasurementTime.reduce((acumulador, valorActual) => acumulador + valorActual, 0)
        : 0;
      const falseStateChannels = selectedEquipment.channelsStates.reduce((indices, valor, indice) => {
        if (!valor) {
          indices.push(indice);
        }
        return indices;
      }, []);
      let auxequipmentInterMeasurement = suma;
      for (let indexState = 0; indexState < falseStateChannels.length; indexState++) {
        if (
          !isNil(selectedEquipment.channelsMeasurementTime) &&
          !isNil(selectedEquipment.channelsMeasurementTime[falseStateChannels[indexState]])
        ) {
          auxequipmentInterMeasurement =
            auxequipmentInterMeasurement - selectedEquipment.channelsMeasurementTime[falseStateChannels[indexState]];
        }
      }
      if (parseFloat(selectedEquipment.measureFrequency) < auxequipmentInterMeasurement) {
        newErrors[selectedEquipmentID + "_frequency"] = "not.higher.than.amount.measurement.time.channels";
      }
      setErrors(newErrors);
      setEquipmentInterMeasurement(suma);
      const type = objectMeasures.filter((equip) => equip.name === selectedEquipment.equipmentType);
      setCurrentEquipmentType(type);
      const newMeasureToggle = [];
      const newChannelToggle = [];
      const newZoneToggle = [];

      const newChannelDataToggle = [];
      for (let indexChannel = 0; indexChannel < selectedEquipment.channelsNames.length; indexChannel++) {
        newChannelDataToggle.push(false);
      }
      for (let indexMeasure = 0; indexMeasure < selectedEquipment.pThresholdsRanges.length; indexMeasure++) {
        if (type[0].measures.includes(selectedEquipment.pMeasureNames[indexMeasure])) {
          newMeasureToggle.push(false);
          newChannelToggle.push([]);
          newZoneToggle.push([]);
          for (
            let channelIndex = 0;
            channelIndex < selectedEquipment.pThresholdsRanges[indexMeasure].length;
            channelIndex++
          ) {
            newChannelToggle[indexMeasure].push(false);
            newZoneToggle[indexMeasure].push([]);
            for (
              let zoneIndex = 0;
              zoneIndex < selectedEquipment.pThresholdsRanges[indexMeasure][channelIndex].length;
              zoneIndex++
            ) {
              newZoneToggle[indexMeasure][channelIndex].push(false);
            }
          }
        }
      }
      setMeasureToggle(newMeasureToggle);
      setChannelToggle(newChannelToggle);
      setZoneToggle(newZoneToggle);
      setChannelDataToggle(newChannelDataToggle);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEquipment]);

  useEffect(() => {
    if (!isNil(currentUser)) {
      dispatch(getAssetsDataAction(currentUser.id));
      dispatch(getConfigDataAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  function chunk(array, size) {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
      array.slice(index * size, index * size + size),
    );
  }
  if (assets.loading || isNil(currentUser)) {
    return (
      <div
        style={{ height: "92vh", display: "flex", justifyContent: "center", alignItems: "center" }}
      >{`${intl.formatMessage({ id: "loading" })}...`}</div>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      <div style={{ fontSize: "x-large", padding: "1rem", width: "100%" }}>
        {intl.formatMessage({ id: "asset.configuration" })}
      </div>
      <Box
        sx={{
          minHeight: 200,
          height: isNil(assets) || isEmpty(assets) ? 400 : "80vh",
          width: "100%",
          padding: "1rem",
          "& .actions": {
            color: palette.secondary,
          },
          "& .textPrimary": {
            color: palette.primary,
          },
          overflow: "auto",
        }}
      >
        {!isNil(selectedAsset) && (
          <div
            style={{
              border: `1px solid ${palette.primary}`,
              position: "relative",
              margin: "2rem 0 0 1rem",
              padding: "0 1rem 1rem 1rem",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-2rem",
                backgroundColor: palette.likeWhite,
                padding: "0.2rem 0.4rem 0.2rem 0",
                left: "-1rem",
              }}
            >
              <TextField
                id="asset_to_configure"
                margin="dense"
                style={{ width: "10rem" }}
                variant="outlined"
                defaultValue={selectedAsset.name}
                onChange={async (e) => {
                  const selectedAssetName = e.target.value;
                  getPoints(selectedAssetName);
                  const selectedAsset = assets.data.find((asset) => asset.name === selectedAssetName);
                  setSelectedAsset(selectedAsset);
                  const assetSensIDs = [];
                  for (let index = 0; index < selectedAsset.sensors.length; index++) {
                    assetSensIDs.push(selectedAsset.sensors[index].sensor_ID);
                  }
                  setAssetSensors(assetSensIDs);
                  setEquipments(selectedAsset.equipments);
                  setRealState(true);
                  setSelectedEquipment(selectedAsset.equipments[0]);
                  setSelectedEquipmentID(selectedAsset.equipments[0].equipmentID);
                }}
                select
                label={intl.formatMessage({ id: "assets" })}
                required
              >
                {!isNil(assets.data) &&
                  assets.data.map((asset, index) => {
                    const demarcation = asset.demarcation;
                    const roleInDem =
                      !isNil(currentUser.assetsConfigurations) && !isEmpty(currentUser.assetsConfigurations)
                        ? currentUser.assetsConfigurations[demarcation].role
                        : currentUser.role;
                    const roleInDemAsset =
                      !isNil(currentUser.assetsConfigurations) && !isEmpty(currentUser.assetsConfigurations)
                        ? currentUser.assetsConfigurations[demarcation].assets[asset.name]
                        : currentUser.role;
                    if (roleInDem === "viewer" || roleInDemAsset === "viewer") return null;
                    return (
                      <MenuItem value={asset.name} key={asset.name + index}>
                        {asset.name}
                      </MenuItem>
                    );
                  })}
              </TextField>
            </div>
            <div
              style={{
                border: `1px solid ${palette.primary}`,
                position: "relative",
                margin: "5rem 0 0 1rem",
                padding: "0 1rem 1rem 1rem",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-2rem",
                  backgroundColor: palette.likeWhite,
                  padding: "0.2rem 0.4rem 0.2rem 0",
                  left: "-1rem",
                }}
              >
                {!isNil(equipments) && !isEmpty(equipments) ? (
                  <TextField
                    id="equipment_to_configure"
                    margin="dense"
                    style={{ width: "10rem" }}
                    variant="outlined"
                    defaultValue={selectedEquipmentID}
                    value={selectedEquipmentID}
                    onChange={(e) => {
                      const selectedEquipmentIDOnChange = e.target.value;
                      const selectedEquipmentChange = equipments.find(
                        (equip) => equip.equipmentID === selectedEquipmentIDOnChange,
                      );
                      setRealState(true);
                      setSelectedEquipment(selectedEquipmentChange);
                      setSelectedEquipmentID(selectedEquipmentIDOnChange);
                      setAsignedChannelNames(selectedEquipmentChange.channelsNames);
                    }}
                    select
                    label={intl.formatMessage({ id: "equipment" })}
                    required
                  >
                    {equipments.map((equipment, index) => (
                      <MenuItem value={equipment.equipmentID} key={equipment.equipmentID + index}>
                        {equipment.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : null}
              </div>

              {(currentUser.role === "admin" || currentUser.role === "administrator") &&
                !isNil(setSelectedEquipmentID) && (
                  <div style={{ fontSize: "x-large", marginTop: "3rem", width: "100%" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", margin: "0.5rem" }}>
                      {currentUser.role === "admin" && (
                        <>
                          {selectedEquipment.equipmentType === "DAS" ? (
                            <>
                              <TextField
                                id={selectedEquipmentID + "_spatialResolution"}
                                style={{ margin: "0 0.2rem" }}
                                value={selectedEquipment.spatialResolution}
                                onChange={(e) => {
                                  const newErrors = { ...errors };
                                  if (isEmpty(e.target.value)) {
                                    newErrors[e.target.id] = "not.empty";
                                  } else {
                                    delete newErrors[e.target.id];
                                  }
                                  setErrors(newErrors);
                                  const index = equipments.findIndex(
                                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                                  );
                                  const newEquipments = [...equipments];
                                  const updatedEquipment = { ...newEquipments[index] };
                                  updatedEquipment.spatialResolution = parseFloat(e.target.value);
                                  newEquipments[index] = updatedEquipment;
                                  setRealState(false);
                                  setSelectedEquipment(updatedEquipment);
                                  setEquipments(newEquipments);
                                }}
                                error={errors[selectedEquipmentID + "_spatialResolution"] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "channel.spatial.resolution" })}
                                required
                                type="number"
                              ></TextField>
                              {!isNil(errors[selectedEquipmentID + "_spatialResolution"]) && (
                                <ErrorText>
                                  {intl.formatMessage({ id: errors[selectedEquipmentID + "_spatialResolution"] })}
                                </ErrorText>
                              )}
                              <TextField
                                id={selectedEquipmentID + "_criticalArea"}
                                style={{ margin: "0 0.2rem" }}
                                value={selectedEquipment.criticalArea.distance}
                                onChange={(e) => {
                                  const newErrors = { ...errors };
                                  if (isEmpty(e.target.value)) {
                                    newErrors[e.target.id] = "not.empty";
                                  } else {
                                    delete newErrors[e.target.id];
                                  }
                                  setErrors(newErrors);
                                  const index = equipments.findIndex(
                                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                                  );
                                  const newEquipments = [...equipments];
                                  const updatedEquipment = { ...newEquipments[index] };
                                  updatedEquipment.criticalArea.distance = parseFloat(e.target.value);
                                  newEquipments[index] = updatedEquipment;
                                  setRealState(false);
                                  setSelectedEquipment(updatedEquipment);
                                  setEquipments(newEquipments);
                                }}
                                error={errors[selectedEquipmentID + "_criticalArea"] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "critical.area" })}
                                type="number"
                                required
                              ></TextField>
                              {!isNil(errors[selectedEquipmentID + "_criticalArea"]) && (
                                <ErrorText>
                                  {intl.formatMessage({ id: errors[selectedEquipmentID + "_criticalArea"] })}
                                </ErrorText>
                              )}
                              <TextField
                                id={selectedEquipmentID + "_protecionArea"}
                                style={{ margin: "0 0.2rem" }}
                                value={selectedEquipment.protectionArea.distance}
                                onChange={(e) => {
                                  const newErrors = { ...errors };
                                  if (isEmpty(e.target.value)) {
                                    newErrors[e.target.id] = "not.empty";
                                  } else {
                                    delete newErrors[e.target.id];
                                  }
                                  setErrors(newErrors);
                                  const index = equipments.findIndex(
                                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                                  );
                                  const newEquipments = [...equipments];
                                  const updatedEquipment = { ...newEquipments[index] };
                                  updatedEquipment.protectionArea.distance = parseFloat(e.target.value);
                                  newEquipments[index] = updatedEquipment;
                                  setRealState(false);
                                  setSelectedEquipment(updatedEquipment);
                                  setEquipments(newEquipments);
                                }}
                                error={errors[selectedEquipmentID + "_protecionArea"] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "protection.area" })}
                                type="number"
                                required
                              ></TextField>
                              {!isNil(errors[selectedEquipmentID + "_spatialResolution"]) && (
                                <ErrorText>
                                  {intl.formatMessage({ id: errors[selectedEquipmentID + "_spatialResolution"] })}
                                </ErrorText>
                              )}
                              <Button
                                variant="contained"
                                id="area_button"
                                style={{
                                  padding: "0.2rem 0.5rem",
                                  backgroundColor: palette.primary,
                                  color: "white",
                                }}
                                onClick={async () => {
                                  const index = equipments.findIndex(
                                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                                  );
                                  const newEquipments = [...equipments];
                                  const updatedEquipment = {
                                    ...newEquipments[index],
                                    criticalArea: { ...newEquipments[index].criticalArea },
                                    protectionArea: { ...newEquipments[index].protectionArea },
                                  };
                                  const response = await getPointsByAssets(selectedAsset.name);
                                  const polylines = response.data.data;
                                  const criticalArea = updatedEquipment.criticalArea.distance;
                                  const protectionArea = updatedEquipment.protectionArea.distance;

                                  const polys = await offsetPolygonPerSegment(
                                    polylines[0].points,
                                    criticalArea,
                                    protectionArea,
                                    updatedEquipment,
                                    intl,
                                  );

                                  updatedEquipment.criticalArea.polygon = polys.criticalCoords;
                                  updatedEquipment.protectionArea.polygon = polys.protectCoords;
                                  newEquipments[index] = updatedEquipment;
                                  setSelectedEquipment(updatedEquipment);
                                  setEquipments(newEquipments);
                                  toast.success(intl.formatMessage({ id: "polygon.calculated" }), {
                                    className: "toast-success",
                                  });
                                }}
                              >
                                {intl.formatMessage({ id: "calculate.area" })}
                              </Button>
                            </>
                          ) : (
                            <>
                              {" "}
                              <TextField
                                id={selectedEquipmentID + "_frequency"}
                                style={{ margin: "0 0.2rem", width: "13%" }}
                                value={selectedEquipment.measureFrequency}
                                inputProps={{ min: 0, max: 86400 }}
                                onChange={(e) => {
                                  setRealState(false);
                                  handleInterMeasurementTime({
                                    actualID: selectedEquipmentID + "_frequency",
                                    asignedChannelMeasurementTime,
                                    asignedChannelsStates,
                                    equipmentInterMeasurement,
                                    equipments,
                                    errors,
                                    setErrors,
                                    selectedEquipmentID,
                                    setSelectedEquipment,
                                    setEquipments,
                                    value: e.target.value,
                                    setEquipmentInterMeasurement,
                                  });
                                }}
                                type="number"
                                error={errors[selectedEquipmentID + "_frequency"] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "measure.frequency" })}
                                required
                              ></TextField>
                              {!isNil(errors[selectedEquipmentID + "_frequency"]) && (
                                <ErrorText>
                                  {intl.formatMessage({ id: errors[selectedEquipmentID + "_frequency"] })}
                                </ErrorText>
                              )}
                            </>
                          )}
                        </>
                      )}
                      {(currentUser.role === "admin" || currentUser.role === "administrator") && (
                        <>
                          <TextField
                            id={selectedEquipmentID + "_IP"}
                            style={{ margin: "0 0.2rem" }}
                            value={selectedEquipment.ipAddress}
                            onChange={(e) => {
                              const newErrors = { ...errors };
                              const regex =
                                /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                              const isValidInput = regex.test(e.target.value);
                              if (isEmpty(e.target.value)) {
                                newErrors[e.target.id] = "not.empty";
                              } else if (!isValidInput) {
                                newErrors[e.target.id] = "must.ip";
                              } else {
                                delete newErrors[e.target.id];
                              }
                              setErrors(newErrors);
                              const index = equipments.findIndex(
                                (equipment) => equipment.equipmentID === selectedEquipmentID,
                              );
                              const newEquipments = [...equipments];
                              const updatedEquipment = { ...newEquipments[index] };
                              updatedEquipment.ipAddress = e.target.value;
                              newEquipments[index] = updatedEquipment;
                              setRealState(false);
                              setSelectedEquipment(updatedEquipment);
                              setEquipments(newEquipments);
                            }}
                            error={errors[selectedEquipmentID + "_IP"] ? true : false}
                            variant="outlined"
                            label={intl.formatMessage({ id: "ip.address" })}
                            required
                          ></TextField>
                          {!isNil(errors[selectedEquipmentID + "_IP"]) && (
                            <ErrorText>{intl.formatMessage({ id: errors[selectedEquipmentID + "_IP"] })}</ErrorText>
                          )}
                          <LoadingButton
                            variant="contained"
                            size="large"
                            style={{
                              padding: "0.2rem 0.5rem",
                              backgroundColor: disabledPing ? palette.light : palette.primary,
                              color: "white",
                            }}
                            onClick={async () => {
                              const index = equipments.findIndex(
                                (equipment) => equipment.equipmentID === selectedEquipmentID,
                              );
                              const newEquipments = [...equipments];
                              const updatedEquipment = { ...newEquipments[index] };
                              setLoadingPing(true);
                              await pingIpAddress(selectedEquipmentID, updatedEquipment.ipAddress, intl);
                              setLoadingPing(false);
                            }}
                            loading={loadingPing ?? false}
                            disabled={disabledPing}
                          >
                            PING
                          </LoadingButton>
                        </>
                      )}
                    </div>
                  </div>
                )}
              {currentUser.role === "operator" && (
                <div style={{ fontSize: "x-large", marginTop: "2rem", width: "100%" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", margin: "0.5rem" }}></div>
                </div>
              )}
              <ChannelInfo
                asignedChannelSubstructures={asignedChannelSubstructures}
                setAsignedChannelSubstructures={setAsignedChannelSubstructures}
                asignedChannelLength={asignedChannelLength}
                asignedChannelMeasurementTime={asignedChannelMeasurementTime}
                asignedChannelNames={asignedChannelNames}
                asignedChannelSamplingInterval={asignedChannelSamplingInterval}
                asignedChannelSpatialResolution={asignedChannelSpatialResolution}
                asignedChannelsInfo={asignedChannelsInfo}
                asignedChannelsStates={asignedChannelsStates}
                assetSensors={assetSensors}
                channelDataToggle={channelDataToggle}
                channelsSensorsIDs={channelsSensorsIDs}
                chunk={chunk}
                equipmentInterMeasurement={equipmentInterMeasurement}
                equipments={equipments}
                selectedEquipment={selectedEquipment}
                selectedEquipmentID={selectedEquipmentID}
                setAsignedChannelMeasurementTime={setAsignedChannelMeasurementTime}
                setAsignedChannelNames={setAsignedChannelNames}
                setAsignedChannelSpatialResolution={setAsignedChannelSpatialResolution}
                setAsignedChannelsInfo={setAsignedChannelsInfo}
                setAsignedChannelsStates={setAsignedChannelsStates}
                setChannelDataToggle={setChannelDataToggle}
                setEquipments={setEquipments}
                setRealState={setRealState}
                setSelectedEquipment={setSelectedEquipment}
                setchannelSensorsIDs={setchannelSensorsIDs}
                errors={errors}
                setErrors={setErrors}
                points={points}
                asignedChannelSubstructuresToggle={asignedChannelSubstructuresToggle}
                setAsignedChannelSubstructuresToggle={setAsignedChannelSubstructuresToggle}
                intl={intl}
              />

              <div style={{ fontSize: "x-large", marginTop: "1rem", width: "100%" }}>
                {intl.formatMessage({ id: "asset.configuration.thresholds" })}
              </div>
              {!isEmpty(measuresAlerts) &&
                selectedEquipment.pMeasureNames.map((measure, measureIndex) => (
                  <MeasurementInfo
                    asignedChannelNames={asignedChannelNames}
                    channelToggle={channelToggle}
                    chunk={chunk}
                    currentEquipmentType={currentEquipmentType}
                    measure={measure}
                    measureIndex={measureIndex}
                    measureToggle={measureToggle}
                    measuresAlerts={measuresAlerts}
                    setChannelToggle={setChannelToggle}
                    setMeasureToggle={setMeasureToggle}
                    setMeasuresAlerts={setMeasuresAlerts}
                    setThresholdsRanges={setThresholdsRanges}
                    setTuples={setTuples}
                    setTuplesActive={setTuplesActive}
                    setZoneToggle={setZoneToggle}
                    thresholdsRanges={thresholdsRanges}
                    tuples={tuples}
                    tuplesActive={tuplesActive}
                    zoneToggle={zoneToggle}
                    errors={errors}
                    setErrors={setErrors}
                    intl={intl}
                  />
                ))}
              {!isEmpty(measuresAlerts) &&
                selectedEquipment.pMeasureNames.map((measure, measureIndex) => {
                  if (
                    !isNil(currentEquipmentType) &&
                    !isNil(currentEquipmentType[0].computing) &&
                    !currentEquipmentType[0].computing.includes(measure)
                  ) {
                    return null;
                  }
                  return (
                    <>
                      <div style={{ fontSize: "x-large", display: "flex", alignItems: "center" }}>
                        {intl.formatMessage({ id: measure })}
                        <div>
                          <FormControlLabel
                            control={
                              <Checkbox
                                id={"checkbox" + measureIndex}
                                sx={{
                                  color: palette.primary,
                                  "&.Mui-checked": {
                                    color: palette.primary,
                                  },
                                }}
                                checked={measuresAlerts[measureIndex] === 1 ? true : false}
                                onChange={(e) => {
                                  let newMA = clone(measuresAlerts);
                                  if (e.target.checked) {
                                    newMA[measureIndex] = 1;
                                  } else {
                                    newMA[measureIndex] = 0;
                                  }
                                  setMeasuresAlerts(newMA);
                                }}
                              />
                            }
                            label={intl.formatMessage({ id: "send.alert" })}
                            style={{ marginLeft: "auto" }}
                          />
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
            <LoadingButton
              variant="contained"
              size="large"
              style={{
                marginTop: "1rem",
                padding: "0.2rem 0.5rem",
                backgroundColor: disabled ? palette.light : palette.primary,
                color: "white",
              }}
              loading={loading ?? false}
              disabled={disabled}
              onClick={() => {
                updateData({
                  selectedAsset,
                  selectedEquipment,
                  asignedChannelNames,
                  asignedChannelLength,
                  asignedChannelMeasurementTime,
                  asignedChannelSamplingInterval,
                  asignedChannelSpatialResolution,
                  asignedChannelSubstructures,
                  asignedChannelsStates,
                  asignedChannelsInfo,
                  asignedChannelAcquisition,
                  asignedChannelGaugelength,
                  channelsSensorsIDs,
                  alertTimeRange,
                  tuples,
                  tuplesActive,
                  measuresAlerts,
                  thresholdsRanges,
                  equipments,
                  setLoading,
                  dispatch,
                  assets,
                  role: currentUser.role,
                  currentUser,
                  intl,
                });
              }}
            >
              {intl.formatMessage({ id: "save" })}
            </LoadingButton>
          </div>
        )}
        {isNil(selectedAsset) && (
          <div
            style={{ height: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}
          >{`${intl.formatMessage({ id: "no.data" })}`}</div>
        )}
      </Box>
    </div>
  );
};

export default Configuration;
